import { useGetAllTaxesWitCurrentLang } from 'app/modules/taxes/hooks/useTaxes';

import { type OmissionsPaymentsByTax } from '../types';

import { TaxPaymentItem } from './TaxPaymentItem';

export const ContainerPaymentsOmissions = ({
  omissions
}: {
  omissions: Array<OmissionsPaymentsByTax>;
}) => {
  const { data: taxes, loading, error } = useGetAllTaxesWitCurrentLang();

  if (loading || error) {
    return <></>;
  }

  return (
    <>
      {omissions.map((x) => {
        const name = taxes?.find((y) => y.id === x.taxId)?.name;
        const omission = { ...x, taxName: name } as OmissionsPaymentsByTax;
        return (
          <>
            <TaxPaymentItem key={name} omission={omission} />
          </>
        );
      })}
    </>
  );
};
